import { useRef, useState, useLayoutEffect } from 'react';

/* Measures the live rendered height of a DOM node (via ResizeObserver) so a
   fixed-position header can be paired with an accurate flow-space spacer,
   even when its height varies across breakpoints/content (e.g. wrapped
   tagline text, expanded mobile menu). */
export const useElementHeight = () => {
  const ref = useRef(null);
  const [height, setHeight] = useState(0);

  useLayoutEffect(() => {
    if (!ref.current) return;
    const update = () => setHeight(ref.current.offsetHeight);
    update();
    const observer = new ResizeObserver(update);
    observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return [ref, height];
};
